export const privileageAccess = {
  computed: {
    privileges() {
      return this.$system.$state.privileges;
    },
  },
  methods: {
    //有页面权限
    hasPageAccess(key) {
      return !!this.privileges.find(item => item.privilegeName === key);
    },
  },
};
